<template>
    <div>
        <el-row class="searchSection">
            <el-form ref="form" :inline="true" :model="searcheModel" class="external-form">
                <el-form-item label="统计时间">
                    <el-date-picker
                        size="small"
                        v-model="searcheModel.created_at"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="财务审核">
                    <el-select size="small" v-model="searcheModel.finance_audit" placeholder="请选择">
                        <el-option label="不限" value=""></el-option>
                        <el-option label="通过" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="过滤销售额为0的订单">
                    <el-select size="small" v-model="searcheModel.not_have_amount" placeholder="请选择">
                        <el-option label="不限" value=""></el-option>
                        <el-option label="是" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="submitSearch" :loading="customer_loading">搜索</el-button>
                    <el-button @click="resetForm()" size="small">重置</el-button>
                    <ExportFile 
                    v-if="Acs('/sale-analysis/' + activeName)"
                    :url="'/api/export/' + activeName" 
                    :params="searcheModel" 
                    filename="区域分析" 
                    buttonName="导出Excel">
                    </ExportFile>
                </el-form-item>
            </el-form>
        </el-row>

        <el-row class="searchSection">
            <el-tabs type="card" v-model="searcheModel.count_type" @tab-click="submitSearch">
                <el-tab-pane label="按地理区域" name="1"></el-tab-pane>
                <el-tab-pane label="按省份" name="2"></el-tab-pane>
            </el-tabs>
        </el-row>
        <div class="main-bd mg20 pro-visible" v-loading="customer_loading">
            <el-row class="searchSection">
                <el-col :span="18">
                    <h3>区域客户分析（截止到当前时间的数据，不参与筛选）</h3>
                </el-col>
                <el-col :span="2" :offset="4">
                    <CountConfig v-if="Acs('/count-config/view')" :path="$route.path" :tab="searcheModel.tab" :type="count_config_type" key="1"></CountConfig>
                </el-col>
            </el-row>
            <el-table 
            v-if="!customer_loading"
            :data="customer_list" 
            border 
            height="450"
            row-key="id" 
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            :header-cell-style="{background: '#f3faff'}"
            :summary-method="getSummaries"
            show-summary
            key="1"
            >
            <template v-for="(item, index) in customer_fields">
                <el-table-column :prop="item.prop" :label="item.label" v-bind="{ width: item.width }" :key="index">
                    <template slot="header" v-if="item.content">
                        <span>{{item.label}}</span>
                        <el-tooltip class="item" effect="dark" :content="item.content" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        {{ scope.row[item.field] }}<span v-if="item.type && scope.row[item.field]">%</span>
                    </template>
                </el-table-column>
            </template>
            </el-table>
        </div>
        <div class="main-bd mg20 pro-visible" v-loading="clue_loading">
            <el-row class="searchSection">
                <el-col :span="18">
                    <h3>区域线索分析(申请时间)试用客户数和成交客户数中的客户联系人要求是选定线索</h3>
                </el-col>
            </el-row>
            <el-table 
            v-if="!clue_loading"
            :data="clue_list" 
            border 
            height="450"
            row-key="id" 
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            :header-cell-style="{background: '#f3faff'}"
            :summary-method="getSummaries"
            show-summary
            key="2"
            >
            <template v-for="(item, index) in clue_fields">
                <el-table-column :prop="item.prop" :label="item.label" v-bind="{ width: item.width }" :key="index">
                    <template slot="header" v-if="item.content">
                        <span>{{item.label}}</span>
                        <el-tooltip class="item" effect="dark" :content="item.content" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        {{ scope.row[item.field] }}<span v-if="item.type && scope.row[item.field]">%</span>
                    </template>
                </el-table-column>
            </template>
            </el-table>
        </div>

        <div class="main-bd mg20 pro-visible" v-loading="product_loading">
            <el-row class="searchSection">
                <el-col :span="18">
                    <h3>区域合作产品数量（按录单时间）</h3>
                </el-col>
                <el-col :span="2">
                    <TableFields :path="$route.path" :tab="searcheModelProduct.tab" :fields="product_fields" :key="product_count_config_key" @change="changeProductFields"></TableFields>
                </el-col>
                <el-col :span="2" :offset="2">
                    <CountConfig v-if="Acs('/count-config/view')" :path="$route.path" :tab="searcheModelProduct.tab" :type="count_config_type" key="3"></CountConfig>
                </el-col>
            </el-row>
            <el-table 
            v-if="!product_loading"
            :data="product_list" 
            border 
            height="450"
            row-key="id" 
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            :header-cell-style="{background: '#f3faff'}"
            :summary-method="getSummaries"
            show-summary
            key="2"
            >
            <template v-for="(item, index) in product_fields">
                <el-table-column :prop="item.prop" :label="item.label" v-if="product_checked_fields.includes(item.field)" v-bind="{ width: item.width }" :key="index">
                    <template slot="header" v-if="item.content">
                        <span>{{item.label}}</span>
                        <el-tooltip class="item" effect="dark" :content="item.content" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        {{ scope.row[item.field] }}<span v-if="item.type && scope.row[item.field]">%</span>
                    </template>
                </el-table-column>
            </template>
            </el-table>
        </div>

        <div class="main-bd mg20 pro-visible" v-loading="pfm_loading">
            <el-row class="searchSection">
                <el-col :span="18">
                    <h3>区域业绩分析（按录单时间）</h3>
                </el-col>
                <el-col :span="2" :offset="4">
                    <CountConfig v-if="Acs('/count-config/view')" :path="$route.path" :tab="searcheModelPfm.tab" :type="count_config_type" key="5"></CountConfig>
                </el-col>
            </el-row>
            <el-table 
            v-if="!pfm_loading"
            :data="pfm_list" 
            border 
            height="450"
            row-key="id" 
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            :header-cell-style="{background: '#f3faff'}"
            :summary-method="getSummaries"
            show-summary
            key="2"
            >
            <template v-for="(item, index) in pfm_fields">
                <el-table-column :prop="item.prop" :label="item.label" v-bind="{ width: item.width }" :key="index">
                    <template slot="header" v-if="item.content">
                        <span>{{item.label}}</span>
                        <el-tooltip class="item" effect="dark" :content="item.content" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        {{ scope.row[item.field] }}<span v-if="item.type && scope.row[item.field]">%</span>
                    </template>
                </el-table-column>
            </template>
            </el-table>
        </div>
    </div>
  </template>
  <style scoped>
  </style>
  <script>
  import CommonService from "~/services/common";
  import SaleanalysisCount from "~/services/saleanalysisCount";
  import UserCascader from "~/widgets/UserCascader.vue";
  import UserSelect from "~/widgets/UserSelect.vue";
  import Config from "~/config/params";
  import ExportFile from "~/widgets/ExportFile.vue";
  import CountConfig from "~/widgets/CountConfig.vue";
  import TableFields from "~/widgets/TableFields.vue";
  export default {
  
    components: {
        UserCascader,
        UserSelect,
        Config,
        ExportFile,
        CountConfig,
        TableFields
    },
  
    props: {
        activeName: {
            type: String,
            default: ''
        }
    },
  
    data() {
        return {
            count_config_type: 'area',

            customer_loading: false,
            customer_list: [],
            searcheModel: {},
            
            customer_count_config_key: 0,
            customer_fields: [
                {field: 'label', label: '地区丨省份', width: 200},
                {field: 'total_num', label: '总客户数', prop: 'total_num'},
                {field: 'total_num_ratio', label: '客户占比', type: 'ratio'},
                {field: 'try_out_num', label: '试用客户数', prop: 'try_out_num', content:'开通过试用单的客户', width: 120},
                {field: 'try_out_num_ratio', label: '试用占比', type: 'ratio'},
                {field: 'deal_num', label: '成交客户数', prop: 'deal_num', content:'有正式订单的客户', width: 120},
                {field: 'deal_num_ratio', label: '成交占比', type: 'ratio'},
                {field: 'year_avg_price', label: '客户年均价', content:'客户年均价 = (销售额 / 合同年数) / 订单数', width: 120},
                {field: 'product_num', label: '合作中产品', prop: 'product_num', content:'未到期的产品数', width: 120},
            ],

            clue_count_config_key: 0,
            clue_loading: false,
            clue_list: [],
            searcheModelClue: {},
            clue_fields: [
                {field: 'label', label: '地区丨省份', width: 200},
                {field: 'total_num', label: '线索数量', prop: 'total_num'},
                {field: 'total_num_ratio', label: '线索占比', type: 'ratio'},
                {field: 'true_num', label: '申请人属实', prop: 'true_num'},
                {field: 'leader_true_num', label: '负责人属实', prop: 'leader_true_num'},
                {field: 'all_true_num', label: '申请人和负责人均属实', prop: 'all_true_num'},
                {field: 'bind_customer_num', label: '关联客户线索数', prop: 'bind_customer_num'},
                {field: 'customer_num', label: '关联客户数', prop: 'customer_num'},
                {field: 'try_out_customer_num', label: '试用客户数', prop: 'try_out_customer_num', content:'开通过试用单的客户', width: 120},
                {field: 'deal_customer_num', label: '成交客户数', prop: 'deal_customer_num', content:'有正式订单的客户', width: 120},
            ],

            products:[],
            product_count_config_key: 0,
            product_loading: false,
            product_list: [],
            searcheModelProduct: {},
            product_fields: [],
            product_checked_fields: [],


            pfm_count_config_key: 0,
            pfm_loading: false,
            pfm_list: [],
            searcheModelPfm: {},
            pfm_fields: [
                {field: 'label', label: '地区丨省份', width: 200},
                {field: 'total_amount', label: '销售额', prop: 'total_amount'},
                {field: 'total_amount_ratio', label: '销售额占比', type: 'ratio'},
                {field: 'year_avg_price', label: '销售额年均价'},
                {field: 'pfm_amount', label: '新增业绩', prop: 'pfm_amount'},
                {field: 'pfm_amount_ratio', label: '新增业绩占比', type: 'ratio'},
                {field: 'pfm_order_num', label: '新增单数', prop: 'pfm_order_num'},
                {field: 'renew_amount', label: '续费业绩', prop: 'renew_amount'},
                {field: 'renew_amount_ratio', label: '续费业绩占比', type: 'ratio'},
                {field: 'renew_order_num', label: '续费单数', prop: 'renew_order_num'},
            ],
        };
    },
  
    mounted() {
        
    },
  
    created() {
        this.getCommonProductsList();
        this.resetForm();
    },
  
    methods: {
        //重置按钮
        resetForm() {
            this.searcheModel = {
                created_at: Config.getDataTimes('this_week'),
                path: this.$route.path,
                tab: 'area-customer',
                finance_audit: '',
                count_type: '1',
                not_have_amount: '',
            };
            this.list = [];
            this.submitSearch();
        },
    
        // 筛选查询
        submitSearch() {
            let params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            this.getCustomer(params);

            this.searcheModelClue = _.clone(params);
            this.searcheModelClue.tab = 'area-clue';
            this.getClueList(this.searcheModelClue);

            this.searcheModelProduct = _.clone(params);
            this.searcheModelProduct.tab = 'area-product';
            this.getProductList(this.searcheModelProduct);

            this.searcheModelPfm = _.clone(params);
            this.searcheModelPfm.tab = 'area-pfm';
            this.getPfmList(this.searcheModelPfm);
        },
    
        getCustomer(params) {
            // loading 动画
            this.customer_loading = true;
            SaleanalysisCount.getList(params, params.tab).then((res) => {
                if (res.code == 0) {
                    this.customer_list = res.data;
                }
                this.customer_loading = false;
            }).catch((err) => {
                console.error(err);
                this.customer_loading = false;
            });
        },

        getClueList(params) {
            // loading 动画
            this.clue_loading = true;
            SaleanalysisCount.getList(params, params.tab).then((res) => {
                if (res.code == 0) {
                    this.clue_list = res.data;
                }
                this.clue_loading = false;
            }).catch((err) => {
                console.error(err);
                this.clue_loading = false;
            });
        },

        getProductList(params) {
            // loading 动画
            this.product_loading = true;
            SaleanalysisCount.getList(params, params.tab).then((res) => {
                if (res.code == 0) {
                    this.product_list = res.data;
                }
                this.product_loading = false;
            }).catch((err) => {
                console.error(err);
                this.product_loading = false;
            });
        },


        getPfmList(params) {
            // loading 动画
            this.pfm_loading = true;
            SaleanalysisCount.getList(params, params.tab).then((res) => {
                if (res.code == 0) {
                    this.pfm_list = res.data;
                }
                this.pfm_loading = false;
            }).catch((err) => {
                console.error(err);
                this.pfm_loading = false;
            });
        },
        
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                // 第一列不计算合计，显示自定义的文字内容
                if (index === 0) {
                    sums.push('合计：' + data.length + '条');
                    return;
                }
                // 初始化合计值为0
                let sum = 0;
                // 遍历数据，累加顶级行的值
                data.forEach(item => {
                    // 累加当前项的值，注意转换为数字
                    sum += Number(item[column.property]);
                });
                // 如果所有值都是数字，则显示合计结果，否则显示'-'
                if (!isNaN(sum)) {
                    sums.push(Math.round(sum * 100) / 100); // 保留两位小数
                } else {
                    sums.push('--');
                }
            });
            return sums;
        },


        changeProductFields(val){
            this.product_checked_fields = val;
        },

        getCommonProductsList(){
            //加载产品列表
            this.product_fields = [
                {field: 'label', label: '地区丨省份', width: 200},
            ];
            CommonService.getProducts({
                is_deleted: 0,
                status: 1,
                fields: 'id,name,price,code'
            }).then(res => {
                if (res.code == 0) {
                    this.products = res.data;
                    this.products.forEach(item => {
                        this.product_fields.push({field: 'product_id' + item.id, label: item.name, prop: 'product_id' + item.id});
                    });
                }
            });
        },
    },
  };
  </script>


// WEBPACK FOOTER //
// src/views/count/table/areaAnalysis.vue